import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useAuth } from '../contexts/AuthContext';
import AdminSidebar from '../components/AdminSidebar';
import { Outlet } from 'react-router-dom';
import { useSidebar } from '../contexts/SidebarContext';

export default function AdminDashboardLayout() {
  const { user } = useAuth();
  const sidebar = useSidebar();

  if (!user || user.role !== 'e2e-admin') {
    return (
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1 container mx-auto p-6">
          <div className="bg-yellow-50 border border-yellow-200 text-yellow-900 p-4 rounded">
            Admin access required.
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />
      <div className="flex flex-1">
        <AdminSidebar isOpen={sidebar.isOpen} onOverlayClick={sidebar.close} />
        <div className={`flex-1 flex flex-col ${sidebar.isOpen ? 'md:ml-64' : ''}`}>
          <main className="flex-1 p-4 md:p-6">
            <Outlet />
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
}
